import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { TextCell } from '../components/TextCell';

export const ColumnLikes: ColumnHelperMethodType = (columnHelper) =>
  columnHelper.accessor((row) => row.contentId, {
    id: 'likes',
    cell: ({ row }) => <TextCell>{row.original.likes}</TextCell>,
    header: () => <>Likes</>,
  });
